/**
 * To be used with TypeScript Discriminated Unions in order to make sure no member of a union is ignored
 */
export function exhaustiveCheck(param: never, type: string): never {
  throw new TypeError(`${param} is not a proper ${type}`);
}

/**
 * Sort string values
 */
export const sortStrings = (a: string, b: string) => {
  return String(a).localeCompare(b);
};

/**
 * Returns an Array of object's keys but maintaining their type
 */
export const getTypedKeys = Object.keys as <T extends object>(obj: T) => Array<keyof T>;
